import * as S from "./style";
import { Outlet } from "react-router-dom";

/**
 * Components
*/
import Aside from "../../components/Aside";
import Content from "../Content";

export default function Layout() {
    return (
        <S.Container>
            <Aside />

            <S.Content>
                <Content>
                    <Outlet />
                </Content>
            </S.Content>
        </S.Container>
    );
}
